// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"48028765","682":"687dfb8c","787":"10111284","966":"d4698a0e"}[chunkId] + ".chunk.js";
};